import styled from '@emotion/styled';

export const ModalContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: max-content;
  opacity: ${({ disabled }) => disabled ? 0.7 : 1};
  pointer-events: ${({ disabled }) => disabled ? 'none' : 'auto'};
  position: relative;
`;

export const SectionTitle = styled.h1`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
`;

export const FileSelectGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FileSelectLabel = styled.label`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin: 0;
  display: block;
`;

export const FileSelectWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 350px;
`;

export const FileSelect = styled.select`
  width: 100%;
  min-width: 250px;
  max-width: 350px;
  height: 44px;
  border-radius: 6px;
  background: ${({ hasValue, disabled }) => 
    disabled ? '#f9fafb' : hasValue ? '#ffffff' : '#ffffff'};
  border: 2px solid ${({ hasValue, disabled }) => 
    disabled ? '#e5e7eb' : hasValue ? '#009444' : '#dddddd'};
  padding: 12px 18px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: ${({ hasValue, disabled }) => 
    disabled ? '#9ca3af' : hasValue ? '#333333' : '#666666'};
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  transition: border-color 0.2s ease;
  
  &:focus:not(:disabled) {
    outline: none;
    border-color: #6A42F2;
  }
  
  option {
    background: #ffffff;
    color: #333333;
  }
`;

// 🆕 연도 입력 필드 스타일
export const YearInput = styled.input`
  width: 100%;
  min-width: 250px;
  max-width: 350px;
  height: 44px;
  border-radius: 6px;
  background: ${({ disabled }) => disabled ? '#f9fafb' : '#ffffff'};
  border: 2px solid ${({ disabled }) => disabled ? '#e5e7eb' : '#dddddd'};
  padding: 12px 18px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: ${({ disabled }) => disabled ? '#9ca3af' : '#333333'};
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'text'};
  transition: border-color 0.2s ease;
  
  &:focus:not(:disabled) {
    outline: none;
    border-color: #6A42F2;
  }
  
  &::placeholder {
    color: #666666;
  }
`;

export const ReportSelectGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ReportSelectTitle = styled.h2`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
`;

export const SelectAllWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  border-radius: 3px;
  background: #ffffff;
  border: 1px solid #767676;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  flex-shrink: 0;
  opacity: ${({ disabled }) => disabled ? 0.6 : 1};
  
  &:checked:not(:disabled) {
    background: #6A42F2;
    border-color: #6A42F2;
  }
  
  &:focus:not(:disabled) {
    outline: 2px solid rgba(106, 66, 242, 0.3);
    outline-offset: 2px;
  }
`;

export const CheckboxLabel = styled.label`
  color: ${({ disabled }) => disabled ? '#9ca3af' : '#333333'};
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  display: flex;
  align-items: center;
`;

export const ReportListBox = styled.div`
  width: 100%;
  min-height: 200px;
  border-radius: 6px;
  background: ${({ disabled }) => disabled ? '#f9fafb' : '#f9fafb'};
  border: 1px solid #dddddd;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  opacity: ${({ disabled }) => disabled ? 0.7 : 1};
`;

export const ReportItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 2px 0;
`;

export const ReportLabel = styled.label`
  color: ${({ disabled }) => disabled ? '#9ca3af' : '#333333'};
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  flex: 1;
  margin-top: 1px;
`;

export const FileNameGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FileNameLabel = styled.label`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin: 0;
  display: block;
`;

export const FileNameInput = styled.input`
  width: 100%;
  max-width: 500px;
  height: 44px;
  border-radius: 6px;
  background: ${({ disabled }) => disabled ? '#f9fafb' : '#ffffff'};
  border: 1px solid #dddddd;
  padding: 12px 16px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: ${({ disabled }) => disabled ? '#9ca3af' : '#000000'};
  transition: border-color 0.2s ease;
  box-sizing: border-box;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'text'};
  
  &:focus:not(:disabled) {
    outline: none;
    border-color: #6A42F2;
  }
  
  &::placeholder {
    color: #999999;
  }
`;

export const GenerateButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 16px;
`;

export const GenerateButton = styled.button`
  width: 120px;
  height: 44px;
  border-radius: 6px;
  background: ${({ disabled }) => disabled ? '#cccccc' : '#6A42F2'};
  border: none;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    background: #5936e8;
  }
`;

// 🔧 추가: 로딩 오버레이 스타일들
export const GeneratingOverlay = styled.div`
  position: sticky; /* 🔧 핵심: sticky positioning */
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%); /* 수직 중앙 정렬 */
  
  /* 오버레이 배경 */
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(3px);
  
  /* 레이아웃 */
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* 크기 및 위치 */
  height: 100vh; /* 전체 뷰포트 높이 */
  margin: -50vh 0; /* 상하 마진으로 중앙 배치 */
  
  /* 스타일링 */
  border-radius: 8px;
  z-index: 1000;
  
  /* 포인터 이벤트 */
  pointer-events: auto;
`;

// 🔧 대안: 더 간단한 방법
export const GeneratingOverlaySimple = styled.div`
  position: fixed; /* viewport 기준 고정 */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  
  /* 배경 */
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(3px);
  
  /* 크기 */
  width: 90%;
  max-width: 500px;
  
  /* 스타일링 */
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  
  /* 레이아웃 */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`;

export const GeneratingContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 24px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  max-width: 400px;
  border: 1px solid rgba(106, 66, 242, 0.1);
  width: 100%;
`;

export const GeneratingSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #e5e7eb;
  border-top: 4px solid #6A42F2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 24px;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const GeneratingText = styled.div`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  line-height: 28px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const GeneratingSubtext = styled.div`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
`;